import { IS_STORY_ENABLED } from '$func/environmentInfo'
import { STORY_RIBBONS_HEIGHT } from '$comp/_app/components/story/constants'

const defaultCssVars: Record<string, string> = {
  '--view-story-ribbon-height': IS_STORY_ENABLED
    ? `${STORY_RIBBONS_HEIGHT}px`
    : '0px',
}

function setCssVar(name: string, value: string) {
  document.documentElement?.style.setProperty(name, value)
}
export function initializeCssVars() {
  Object.entries(defaultCssVars).forEach(args => setCssVar.apply(null, args))
}
